<mat-toolbar color="primary">
  <span id="møteprotokoll-generer-protokoll-debug-dialog-tittel">{{ 'Generer protokoll (debug)'|translate }}</span>
  <button mat-icon-button aria-label="Lukk dialog" (click)="avbryt()">
    <mat-icon fontSet="ion-ios-close-empty" class="mat-icon--ionic-ikon"/>
  </button>
</mat-toolbar>
@if (laster()) {
  <mat-progress-bar mode="indeterminate"/>
}

<form [formGroup]="skjema" (ngSubmit)="genererProtokoll()" data-testid="møteprotokoll-generer-protokoll-debug-skjema" novalidate>
  <mat-dialog-content class="skjema">
    <mat-form-field>
      <mat-label>{{ 'Prompt'|translate }}</mat-label>
      <textarea matInput [formControl]="skjema.controls.prompt" rows="15" data-testid="prompt-felt"></textarea>
    </mat-form-field>

    <mat-form-field>
      <mat-label>{{ 'Transkripsjon'|translate }}</mat-label>
      <textarea matInput [formControl]="skjema.controls.transkripsjon" rows="15" data-testid="transkripsjon-felt"></textarea>
    </mat-form-field>
  </mat-dialog-content>
  <mat-dialog-actions align="end">
    <button mat-button type="button" (click)="avbryt()">{{ 'Avbryt'|translate }}</button>
    <submit-button [skjema]="skjema" [arbeidPaagaar]="genererer()" spinnerTekst="{{'Genererer...'|translate}}">
      {{ 'Generer protokoll'|translate }}
    </submit-button>
  </mat-dialog-actions>
</form>
